module.exports = __webpack_public_path__ + "img/150h100_s_dvumya_fortochkami_50h50_po_krayam_nizhney_chasti.c61d0d97.svg";